<template>
  <header class="header">
    <div class="header__inner">
      <div class="header__logo">
        <a href="/">
          <img class="is-pc" src="/assets/common/img_logo_header.png" alt="病院事務職求人.com">
          <img class="is-sp" src="/assets/common/img_logo_sp.png" alt="病院事務職求人.com">
        </a>
      </div>
      <div class="header__cal">
        <a href="tel:0120992975">
          <img class="is-pc" src="/assets/common/img_calnumber.png" alt="0120-992-975">
          <img class="is-sp" src="/assets/common/img_calnumber_sp.png" alt="0120-992-975">
        </a>
      </div>
    </div>
  </header>
</template>

<script>
  export default {

  }
</script>
